<h2 mat-dialog-title>New Version</h2>
<div mat-dialog-content>
  <p>New version of your app is available. Please click reload to continue.</p>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end">
  <button mat-button (click)="onChoice(false)">Dismiss</button>
  <button mat-raised-button (click)="onChoice(true)" color="primary" cdkFocusInitial>Reload</button>
</div>
